import { forwardRef, createElement } from 'react';
import { BaseInput } from './__internal__/BaseInput';
import { InputProps } from './types';

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input({ ...props }, ref) {
  return <BaseInput {...props} ref={ref} />;
});
